(() => {
  const initCatalogue = (root) => {
    if (!root || root.dataset.dlbCatalogueReady === 'true') return;
    root.dataset.dlbCatalogueReady = 'true';

    const panel = root.querySelector('[data-dlb-filter-panel]');
    const overlay = root.querySelector('[data-dlb-filter-overlay]');
    const openButton = root.querySelector('[data-dlb-filter-open]');
    const closeButton = root.querySelector('[data-dlb-filter-close]');
    const filterForm = root.querySelector('[data-dlb-filter-form]');

    const closeFilters = () => {
      panel?.classList.remove('is-open');
      overlay?.classList.remove('is-open');
      document.body.classList.remove('dlb-filter-open');
      openButton?.focus();
    };

    const openFilters = () => {
      panel?.classList.add('is-open');
      overlay?.classList.add('is-open');
      document.body.classList.add('dlb-filter-open');
      closeButton?.focus();
    };

    openButton?.addEventListener('click', openFilters);
    closeButton?.addEventListener('click', closeFilters);
    overlay?.addEventListener('click', closeFilters);

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && panel?.classList.contains('is-open')) closeFilters();
    });

    root.querySelectorAll('[data-dlb-sort-select]').forEach((select) => {
      select.addEventListener('change', () => {
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', select.value);
        url.searchParams.delete('page');
        window.location.assign(url.toString());
      });
    });

    if (filterForm) {
      filterForm.addEventListener('change', (event) => {
        if (window.matchMedia('(min-width: 900px)').matches && event.target.matches('input[type="checkbox"]')) {
          filterForm.requestSubmit();
        }
      });
    }
  };

  const initAll = (scope = document) => {
    scope.querySelectorAll('[data-dlb-catalogue]').forEach(initCatalogue);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
